import styled from 'styled-components';
import {
  Container as OperationsTableContainer,
  Header as OperationsTableHeader,
} from '../OperationsTable/OperationsTable.styles';
import { OPERATIONS_TABLE_COLUMNS } from '../../Transactions.constants';

export const Container = OperationsTableContainer;

export const Header = OperationsTableHeader;

export const Row = styled.div`
  display: grid;
  grid-template-columns: ${OPERATIONS_TABLE_COLUMNS};
  gap: 16px;
  align-items: center;
  height: 68px;
  padding: 0 20px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};

  &:last-child {
    border-bottom: none;
  }
`;
